import React, { useState } from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  useTheme,
  useMediaQuery,
  CardActionArea,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { checkProductInStorage, handleAddToList } from "../api/productUtils";
import { fetchMoreDetails } from "../api/fetchMoreDetails";
import ProductDetails from "../ProductDetails";
import isMobile from "../isMobile";

const Product = React.memo(({ item, setProducts, products }) => {
  const [message, setMessage] = useState("");
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const mobileView = isMobile();
  const charLimit = mobileView ? 30 : 60;

  console.log(item);
  

  const handleCardClick = async () => {
    setOpenDetails(true);
    let details;
    const { global_id } = item;
    if (global_id) {
      details = await fetchMoreDetails(global_id);
    } else {
      details = item;
    }
    setSelectedProduct(details);
  };

  const fetchUrl = async (globalId) => {
    const details = await fetchMoreDetails(globalId);
    if (details) {
      return details.url;
    }
  };

  const handleAdd = () => {
    handleAddToList(item, setProducts);
    setMessage("Product Added");
    setTimeout(() => setMessage(""), 2000);
  };

  const handleRemove = () => {
    const storedProducts = JSON.parse(localStorage.getItem("products")) || [];
    if (storedProducts.length > 0) {
      const updatedProducts = storedProducts.filter(
        (product) => product.id !== item.id
      );
      localStorage.setItem("products", JSON.stringify(updatedProducts));
      setProducts(updatedProducts);
      setMessage("Product Removed");
      setTimeout(() => setMessage(""), 2000);
    }
  };

  const truncatedName =
    item.name.length > charLimit
      ? item.name.substring(0, charLimit) + "..."
      : item.name;

  return (
    <>
      <Grid
        item
        xs={6}
        sm={4}
        md={3}
        key={`${item.id}-${item.name}`}
        style={{ display: "flex" }}
      >
        <CardActionArea onClick={handleCardClick}>
          <Card
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              padding: "10px",
              border: "1px solid #d3d3d3",
              borderRadius: "8px",
              boxShadow: "none",
              minHeight: "350px",
              cursor: "pointer",
            }}
          >
            <CardMedia
              component="img"
              height="140"
              image={item.clean_image_url || item.image_url || ""}
              alt={item.name}
              style={{ objectFit: "contain", marginBottom: "10px" }}
            />
            <CardContent
              style={{
                padding: "0",
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "3px",
                }}
              >
                <Typography
                  variant="body1"
                  component="div"
                  style={{
                    fontSize: "0.9rem",
                    color: "#000",
                    textAlign: "left",
                    flexShrink: 0,
                  }}
                >
                  {truncatedName}
                  {item.name.length > charLimit && (
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCardClick();
                      }}
                      style={{ color: "blue", cursor: "pointer" }}
                    >
                      {" "}
                      Read more
                    </span>
                  )}
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Typography
                  variant="body2"
                  color="text.primary"
                  style={{
                    fontSize: "0.9rem",
                    color: "#000",
                    marginBottom: "5px",
                    textAlign: "left",
                    fontWeight: "bold",
                    flexShrink: 0,
                  }}
                >
                  ${item.current_price}
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "8px",
                    flexShrink: 0,
                  }}
                >
                  {item.merchant_logo && (
                    <img
                      src={item.merchant_logo}
                      alt={`${item.merchant_name} Logo`}
                      style={{
                        maxWidth: "20px",
                        maxHeight: "20px",
                        objectFit: "contain",
                        marginRight: "5px",
                      }}
                    />
                  )}
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    style={{
                      fontSize: "0.8rem",
                      textAlign: "left",
                      marginBottom: "5px",
                    }}
                  >
                    {item.merchant_name || item.merchant}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    flexShrink: 0,
                  }}
                >
                  {message && (
                    <>
                      <Typography
                        variant="body2"
                        color="text.primary"
                        style={{ fontSize: "0.8rem", marginRight: "3px" }}
                      >
                        {message}
                      </Typography>
                      <CheckIcon color="success" />
                    </>
                  )}
                  {!checkProductInStorage(item, products) && !message ? (
                    <Button
                      variant="outlined"
                      color="primary"
                      size={mobileView ? "small" : "large"}
                      style={{
                        fontSize: "0.7rem",
                        textTransform: "none",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAdd();
                      }}
                      component="div"
                    >
                      Add To List
                    </Button>
                  ) : (
                    !message && (
                      <Button
                        variant="outlined"
                        color="secondary"
                        size={mobileView ? "small" : "large"}
                        style={{
                          fontSize: "0.7rem",
                          textTransform: "none",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemove();
                        }}
                        component="div"
                      >
                        Remove
                      </Button>
                    )
                  )}
                  {item.global_id && (
                    <Button
                      variant="outlined"
                      color="primary"
                      size={mobileView ? "small" : "large"}
                      style={{
                        fontSize: "0.7rem",
                        textTransform: "none",
                      }}
                      component="div"
                      onClick={async (e) => {
                        e.stopPropagation();
                        const url = await fetchUrl(item.global_id);
                        window.location.href = url;
                      }}
                    >
                      Buy Now
                    </Button>
                  )}
                </div>
              </Box>
            </CardContent>
          </Card>
        </CardActionArea>
      </Grid>
      {selectedProduct && (
        <ProductDetails
          open={openDetails}
          handleClose={() => setOpenDetails(false)}
          productDetails={selectedProduct}
          setProducts={setProducts}
          products={products}
        />
      )}
    </>
  );
});

export default Product;
